import React from "react";

const Logo: React.FC = () => {
  return (
    <div className="flex shrink-0 items-center">
      <a href="/" className="block shrink-0 leading-none">
        <img
          src="/logo.png"
          alt="Dom Belloni Logo"
          width={200}
          height={40}
          className="h-8 max-h-10 w-auto cursor-pointer object-contain object-left sm:h-9 lg:h-10"
        />
      </a>
    </div>
  );
};

export default Logo;
